import f from "../../funcs";
import $ from "jquery";
import Events from "../Events";
import DragDrop from "../DragDrop";
import "css!classes/scroll/ScrollTrack";


// desktop chrome, opera, ie, ff
// NOT MOBILE
let brow = f.aboutBrow();
let BROWSER_WITH_STATIC_WHEEL = !brow.isMobile && !brow.isApple;

// ползунок для скролла (или для тебя детка)
let ScrollTrack = Events.extend("ScrollTrack", {
    wheelStep: 21,

    init(params) {
        params = f.deepMixin({}, params);

        // vertical or horizontal
        this.orientation = params.orientation || "vertical";

        if ( params.wheelStep ) {
            this.wheelStep = params.wheelStep;
        }

        this.position = 0; // px

        this.initElems(params);
        this.initDragDrop(params);
        this.initMoveOnClick();

        if ( params.$box || params.box ) {
            this.setBox(params.$box || params.box);
        }

        this.draw();

        if ( params.wheel ) {
            this.listenWheel(this.$box);
        }
    },

    setBox(box) {
        this.initBox({ box });

        let boxSize;
        if ( this.orientation == "vertical" ) {
            boxSize = this.box.offsetHeight;
        } else {
            boxSize = this.box.offsetWidth;
        }
        this.overview = boxSize;
        this.viewport = boxSize;

        this.maxPosition = this.overview - this.viewport;

        this.$box.append(this.$el);
    },

    initElems() {
        this.$el = $("<div class='ScrollTrack'></div>");

        this.el = this.$el[0];
        this.$el.addClass("ScrollTrack-" + this.orientation);
        this.$track = $("<div class='ScrollTrack-track'></div>").appendTo(this.$el);
        this.track = this.$track[0];
        this.$thumb = $("<div class='ScrollTrack-thumb'></div>").appendTo(this.$track);
        this.thumb = this.$thumb[0];
    },

    draw() {
        let ratio = this.viewport / this.overview;
        let thumbSize = this.viewport * ratio;
        let minThumbSize = 15;
        let thumbPosition = this.position * ratio;

        if ( minThumbSize > thumbSize ) {
            thumbSize = minThumbSize;
            thumbPosition = Math.min(this.viewport - minThumbSize, thumbPosition);
            thumbPosition = Math.max(thumbPosition, 0);
        }

        if ( this.orientation == "vertical" ) {
            this.el.style.height = this.viewport + "px";
            this.thumb.style.height = thumbSize + "px";
            this.thumb.style.top = thumbPosition + "px";
            this.thumb.style.bottom = "initial";
        } else {
            this.el.style.width = this.viewport + "px";
            this.thumb.style.width = thumbSize + "px";
            this.thumb.style.left = thumbPosition + "px";
            this.thumb.style.right = "initial";
        }

        this.el.classList.toggle("ScrollTrack-disable", !ratio || this.viewport >= this.overview);
    },

    initDragDrop() {
        let dragDrop = new DragDrop();
        dragDrop.addElem(this.$thumb);

        dragDrop.on("start", (e) => {
            e.set("position", this.position);
        });

        dragDrop.on("move", (e) => {

            let ratio = this.viewport / this.overview;
            let delta;
            let position;

            if ( this.orientation == "vertical" ) {
                delta = e.dy;
            } else {
                delta = e.dx;
            }

            position = e.start.get("position") + delta / ratio;
            this.setPosition(position);

        });

        // @see CellClick
        dragDrop.on("end", (e) => {
            this.trigger("end", e);
        });

        this.dragDrop = dragDrop;
    },

    initMoveOnClick() {
        this.listenTo(this.$track, "click", (e) => {
            if ( e.target != this.$track[0] ) {
                return;
            }

            let rect = this.el.getBoundingClientRect();
            let point = f.getMousePoint(e);
            let ratio = this.viewport / this.overview;
            let position;

            if ( this.orientation == "vertical" ) {
                position = point.y - rect.top;
            } else {
                position = point.x - rect.left;
            }

            position = position / ratio;
            this.setPosition(position);
        });
    },

    setPosition(position, options) {
        options = f.deepMixin({ trigger: true }, options);

        position = Math.min(position, this.overview - this.viewport);
        position = Math.max(position, 0);

        if ( this.position != position ) {
            let delta = position - this.position;
            this.position = position;

            if ( options.trigger ) {
                this.trigger("move", {
                    delta,
                    position
                });
            }

            this.draw();
        }
    },

    initBox() {
        f.initBox.apply(this, arguments);
    },

    setViewport(viewport) {
        this.viewport = viewport;
        this.maxPosition = this.overview - this.viewport;
    },

    setOverview(overview) {
        this.overview = overview;
        this.maxPosition = this.overview - this.viewport;
    },

    destroy() {
        this.dragDrop.destroy();
        this.clearEvents();
    },

    listenWheel($box) {
        let wheelEvent = "onwheel" in document.createElement("div") ? "wheel" // Modern browsers support "wheel"
            : document.onmousewheel !== undefined ? "mousewheel" // Webkit and IE support at least "mousewheel"
                : "DOMMouseScroll"; // let's assume that remaining browsers are older Firefox

        if ( this._listen$box ) {
            this.stopListening(this._listen$box, wheelEvent);
        }
        this._listen$box = $box;

        this.boostPercent = 0;
        this.maxStep = this.wheelStep * 10;

        this.listenTo($box, wheelEvent, (e) => {
            if ( ~e.target.className.search(/ScrollTrack/i) ) e.target = $box[0].children[0].children[0];
            let wheelDelta = e.originalEvent.deltaY || e.originalEvent.detail || (-1 / 3 * e.originalEvent.wheelDelta);
            let vector = wheelDelta > 0 ? 1 : -1;
            let step = this.wheelStep;

            // чем дальше в скролл, те толще партизаны
            if ( BROWSER_WITH_STATIC_WHEEL ) {
                this.boostPercent++;
                this.boostPercent = Math.min(this.boostPercent, 100);

                step += (this.maxStep - this.wheelStep) * (this.boostPercent / 100);

                // притормози дружок
                clearInterval(this._wheelBoostInterval);
                this._wheelBoostInterval = setInterval(() => {
                    this.boostPercent -= 10;
                    this.boostPercent = Math.max(this.boostPercent, 0);

                    if ( this.boostPercent <= 0 ) {
                        clearInterval(this._wheelBoostInterval);
                    }
                }, 300);
            }

            wheelDelta = Math.round(step * vector);


            let preventWheel = false;
            this.trigger("beforeWheel", {
                type: "beforeWheel",
                target: e.target,
                delta: wheelDelta,
                preventWheel() {
                    preventWheel = true;
                }
            });

            // don't wheel in sub area
            // @see grid/behavior/Scroll
            if ( preventWheel ) {
                return;
            }

            this.setPosition(
                this.position + wheelDelta
            );
        });
    }

});

export default ScrollTrack;
